import * as React from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Dropdown,
  Form,
  FormGroup,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  OverlayTrigger,
  Tooltip,
  ListGroup
} from "react-bootstrap";
import { UserService } from "../../Common/Services/UserService";
import { DocMultiSelect } from "../../Common/Components/DocMultiselect";
import BootstrapTable from 'react-bootstrap-table-next';
import { SingleSearchDropdownListBootrap } from "../../Common/Components/SingleSearchDropdownListBootrap";
import cellEditFactory from 'react-bootstrap-table2-editor';
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FaPencilAlt } from "react-icons/fa";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { JobServices } from "../../Common/Services/JobServices";
import DatePicker from "react-datepicker";
import { Utils } from "../../Common/Utilis";
import { VendorService } from "../../Common/Services/VendorService";
import { DocumentService } from "../../Common/Services/DocumentService";
import { DocumentTypeSearch } from "../DocumentTypeSearch";
import { DepartmentSearch } from "../DepartmentSearch";
import { TransactionService } from "../../Common/Services/TransactionService";
import Customerorderslideout from ".././Customerorderslideout";
import { resolve, reject } from "q";
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import "../../App.scss";
import ".././slideout.scss";
import { VendorSearch } from "../../Common/Components/VendorSearch";
import { CustomerSearch } from "../../Common/Components/CustomerSearch";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import {
  FaArrowUpFromBracket,
  FaCircleMinus,
  FaCirclePlus,
  FaEllipsis,
  FaFolderOpen
} from "react-icons/fa6";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import moment from "moment";
import { CustomerService } from "../../Common/Services/CustomerService";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import { InvoiceService } from "../../Common/Services/InvoiceService";
import { MdDesignServices } from "react-icons/md";
import { MdBuild } from "react-icons/md";
import { confirmAlert } from "react-confirm-alert";
import { DropdownMultiSelect } from "../../Common/Components/DropdownMultiSelect";
import { PartTemplateService } from "../../Common/Services/PartTemplateService";
import { debug } from "console";
import DocumentAttachment from "./DocumentAttachment";
import Dropzone from "react-dropzone";
import {
  faPlus,
  faMinus,
  faPaperclip
} from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollContainer from "react-indiana-drag-scroll";
import { CommentBox } from "../../Common/Components/CommentBox";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import PDFViewer from ".././pdf-viewer";
import { jsPDF } from "jspdf";
import { pdfjs } from "react-pdf";
import { truncate } from "fs";
import FormControl from "rsuite/esm/FormControl";
import { createAbstractBuilder } from "typescript";

let routeLeavingGuard: any = null;
let docViewerFiles: any = [];
let storage = JSON.parse(localStorage.getItem("storage")!);
let currentUtcTime =
  storage === null ? "America/Chicago" : (storage.currentUtcTime as any);


const formattedDate = Utils.convertUtcToTimezoneFormat(
  new Date(),
  currentUtcTime
);

/** Session cache of downloaded file content (base64 data URLs), keyed by attachment Id. */
const documentFileContentCache = new Map<number, string>();

const hasFileContent = (file: any): boolean => {
  const code = file?.fileCode;
  return typeof code === "string" && code.length > 0 &&
    (code.startsWith("data:") || code.startsWith("blob:"));
};

const getAttachmentCacheKey = (file: any): number | null => {
  const id = file?.id ?? file?.Id;
  if (id == null || id === 0) return null;
  const n = Number(id);
  return Number.isNaN(n) ? null : n;
};

const invalidateDocumentFileCache = (file: any) => {
  const key = getAttachmentCacheKey(file);
  if (key != null) {
    documentFileContentCache.delete(key);
  }
};

const toPreviewDataUrl = (fileCode: string, fileName?: string): string => {
  if (!fileCode) return "";
  if (fileCode.startsWith("data:") || fileCode.startsWith("blob:")) return fileCode;
  const name = (fileName || "").toLowerCase();
  const mime = name.endsWith(".pdf") || !name
    ? "application/pdf"
    : name.endsWith(".png")
      ? "image/png"
      : name.endsWith(".jpg") || name.endsWith(".jpeg")
        ? "image/jpeg"
        : "application/octet-stream";
  return `data:${mime};base64,${fileCode}`;
};

class DocumentSlideout extends React.Component<any, any> {
  private customerSearch: any;
  private trDate: any;
  private fileInputRef: any;
  private parentScroll: any;
  private ChildComment: any;
  private scrollheight: any;
  private footerchk: any;

  renderTooltip = (ids) => {
    return (
      <Tooltip className="LDtoolTipLettercodes" id="button-tooltip" {...ids}>
        {ids.toolTipLettercodes.replaceAll(",", ", ")}
      </Tooltip>
    );
  };

  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.customerSearch = React.createRef();
    this.trDate = React.createRef();
    this.fileInputRef = React.createRef();
    this.scrollheight = React.createRef();
    this.handleVendorChange = this.handleVendorChange.bind(this);
    this.GetUploadFileList = this.GetUploadFileList.bind(this);
    this.OpenViewer = this.OpenViewer.bind(this);
    this.ChildComment = React.createRef();
    this.state = {
      createdName: "",
      createdId: 0,
      openAttach: false,
      openAttachIndex: 0,
      stringId: this.props.stringId ? this.props.stringId : "",
      isControlled: true,
      userLoad: false,
      docNumber: this.props.docNumber ? this.props.docNumber : "",
      isDepartmentLoad: false,
      isDocumentLoad: false,
      savedfilesSeparate: [],
      separateView: false,
      isSpinnerdoc: false,
      isExtracting: false,
      showModal: false,
      selectedFiles: [],
      uploadedFiles: [],
      IsDeleted: true,
      fileSelect:
        "data:application/pdf;base64,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",
      defaultView: "doc-view",
      bulkSelect: false,
      isprevious: false,
      files: [],
      files1: [],
      savedfiles: [],
      newSelectfiles: [],
      totalCount: 0,
      isOpenViewer: false,
      currentZoom: 0.7,
      fileSize: 5242880,
      userdataList: [],
      documentList: [],
      departmentList: [],
      moreActionFileUpload1: [
        { name: "View", eventKey: "view" },
        { name: "Download", eventKey: "download" },
        { name: "Delete", eventKey: "delete" },
      ],
      bankList: [],
      coaOptions: [],
      statusList: [
        { name: "Active", id: "Active" },
        { name: "Obsolete", id: "Obsolete" },
      ],
      Defaultselected: [],
      options: [],
      // depositColumns: this.depositColumns,
      creatNew: false,
      deletedRowIds: [],
      formData: {
        Id: this.props.Id ? this.props.Id : 0,
        department: "",
        documentType: "",
        identifier: "",
        selectedIds: [],
        categoryId: 0
      },
      deposits: [
        {
          srno: 1,
          identifier: "",
          revision: "",
          description: "",
          date: new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime)),
          tenantID: 0,
          createdbyName: "Select",
          createdby: 0,
          approvedbyName: "Select",
          approvedby: 0,
          status: "Active"
        },
      ],
      itemListdatam: [],
      inventorydata: [],
      jobList: [],
      defaultitemname: [],
    };
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
  }

  deleteDocument = () => {
    this.setState({ isSpinner: true });
    let request = { processId: this.state.formData.Id };
    TransactionService.DeleteDocument(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result) {
          toast.success("Document has been deleted successfully.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          this.closeSlideOut();
        } else {
          toast.error("Failed to delete document.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
        }
      })
      .catch((error: any) => {
        this.setState({ isSpinner: false });
        toast.error("An error occurred while deleting the document.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
      });
  };


  setTotalPages = (totalpage) => {
    this.setState({ isExtractOption: false });
  };

  handleSelectedItem1 = (control: any, id: any, abb?: any) => {
    let formData = { ...this.state.formData };
    console.log("handle----", control, id);
    if (control == 1) {
      formData.paymentMethod = id;
      this.setState({ formData });
    } else if (control == 2) {
      let bankid = this.state.bankList.filter((x) => x.id == id);
      let bankname = bankid.length > 0 ? bankid[0].name : "";
      formData.bankId = id;
      this.setState({ formData, bankname });
    } else if (control == 3) {
      formData.accountingDate = id;
      this.setState({ formData });
    } else if (control == 4) {
      formData.department = id;
      this.setState({ formData });
    } else if (control == 5) {
      formData.documentType = id;
      let abbr = this.state.documentList.filter((x) => x.id == id);
      formData.identifier = abbr[0]?.abb ?? "";
      formData.categoryId = id;
      let isControlled = abbr[0]?.controlled ?? "";
      let updatedDeposits = [...this.state.deposits];

      if (!isControlled) {
        updatedDeposits = updatedDeposits.map((item) => ({
          ...item,
          createdbyName: this.state.createdName,
          identifier: "",
          createdby: this.state.createdId
        }));
      }
      this.setState({ formData, isControlled, deposits: updatedDeposits });
    }


  };
  handleCheckboxChange = () => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        isCustomer: !prevState.formData.isCustomer,
        vendorid: 0
      },
    }));
  };

  handleButtonClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleCloseCheckboxChange = () => {
    this.setState((prevState) => ({
      creatNew: !prevState.creatNew,
    }));
  };

  amountBlur = (e, rowIndex, type: any, row: any) => {
    let jobOrderlistByItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobOrderlistByItem))
    );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        if (type === "unitPrice") {
          let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);

          if (itemRows != null && itemRows.length > 0) {
            itemRows.forEach((element) => {
              element.unitPrice = Utils.currencyFormat(timeArray[0]);
            });
          }
        }
      } else {
        if (type === "unitPrice") {
          let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);

          if (itemRows != null && itemRows.length > 0) {
            itemRows.forEach((element) => {
              element.unitPrice = Utils.currencyFormat(e.target.value);
            });
          }
        }
      }
      //this.setState({ jobOrderlistByItem });
      this.setState({ jobOrderlistByItem: jobOrderlistByItem }, () => { });
    } else {
      if (type === "unitPrice") {
        let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);

        if (itemRows != null && itemRows.length > 0) {
          itemRows.forEach((element) => {
            element.unitPrice =
              e.target.value === ""
                ? ""
                : !isNaN(e.target.value)
                  ? Utils.currencyFormat(e.target.value)
                  : e.target.value;
          });
        }
      }

      this.setState({ jobOrderlistByItem: jobOrderlistByItem }, () => { });
    }
  };

  handleZoom = (event) => {
    let currZoom = this.state.currentZoom;
    let updateZoom;
    if (event === "zoomIn") {
      updateZoom = currZoom * 1.5;
    } else {
      updateZoom = currZoom / 1.5;
    }
    // console.log("updateZoom-" + updateZoom);
    this.setState({ currentZoom: updateZoom });
  };

  handleAllCheckbox(event) {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.handleAllCheckbox(event);
    }
  }

  deleteDeposit = () => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.transactionid = this.state.formData.journalEntryID;
    TransactionService.DeleteJournal(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.closeSlideOut();

          toast.success("Journal has been deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });



          this.setState({ isSpinner: false });
          this.closeSlideOut();

        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };

  moreActions = (eventKey: any) => {
    if (eventKey == "DuplicateOrder") {
      const { formData } = this.state;
      this.state.formData.date = new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime));
      this.state.formData.journalEntryID = 0;

      this.setState({ orderType: 'Duplicate' }, () => {
        this.setState({ formData, isStateChanged: true }, () => { });
      });
    }

    else if (eventKey === "Delete") {
      confirmAlert({
        title: "Delete Document",
        message: "Are you sure you want to delete this document? This action cannot be undone. All related document records and uploaded files (including the main document and all associated row files) will be permanently deleted.",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.deleteDocument(),
          },
          {
            label: "No",
            onClick: () => { },
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }


  };


  handleRawChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value != undefined) {
      const maxLength = 8; // Set the maximum length you want
      if (e.target.value.length > maxLength) {
        e.preventDefault();
        e.target.value = e.target.value.slice(0, maxLength);
      }
    }
  };

  updateState = (e: any, row: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      const { formData } = this.state;
      let deposits = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.deposits))
      );

      if (type === "revision") {
        e.preventDefault();
        let itemRows = deposits.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].revision = e.target.value;
        }

        this.setState({ deposits: deposits, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

      } if (type === "rowidentifier") {
        e.preventDefault();
        let itemRows = deposits.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].identifier = e.target.value;
        }

        this.setState({ deposits: deposits, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

      } else if (type === "identifier") {
        e.preventDefault();
        formData.identifier = e.target.value;

        this.setState({ formData, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

      }
      if (type === "description") {
        e.preventDefault();
        let itemRows = deposits.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].description = e.target.value;
        }

        this.setState({ deposits: deposits, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      } else if (type === "date") {
        //  e.preventDefault();

        //  orderData[index].dueDate = e.target.value;


        let today = new Date(e);
        let dateNew =
          today.getMonth() +
          1 +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear().toString().substring(2, 4);
        let todaynew = new Date(dateNew);
        let dateNewt =
          todaynew.getMonth() +
          1 +
          "/" +
          todaynew.getDate() +
          "/" +
          todaynew.getFullYear().toString().substring(0, 4);
        let itemRows = deposits.filter((x) => x.srno == row.srno);

        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].date = dateNewt;

        }


        this.setState({ deposits: deposits, isStateChanged }, () => {
          let id = "txtdescription" + row.srno + "txt";
          //$("#tblOrder").find("input[id^='" + id + "']").focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + id + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
    }
  };

  amountBlurAdditionalItems = (e, rowIndex, type: any, row: any) => {
    const { formData } = this.state;
    let deposits = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.deposits))
    );
    // if (e.target.value.includes(".")) {
    //   const timeArray = e.target.value?.split(".");

    //   if (timeArray[1].length <= 0) {
    //     if (type === "debitAmount") {
    //       let itemRows = deposits.filter((x) => x.srno == row.srno);
    //       if (itemRows != null && itemRows.length > 0) {
    //         itemRows[0].debitAmount = Utils.currencyFormat(timeArray[0]);
    //       }
    //     }else  if (type === "creditAmount") {
    //       let itemRows = deposits.filter((x) => x.srno == row.srno);
    //       if (itemRows != null && itemRows.length > 0) {
    //         itemRows[0].creditAmount = Utils.currencyFormat(timeArray[0]);
    //       }
    //     }
    //   } else {
    //    if (type === "debitAmount") {
    //              let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
    //              e.target.value = newVal;
    //              formData.debitAmount =
    //                e.target.value === ""
    //                  ? ""
    //                  : !isNaN(e.target.value)
    //                  ? Utils.currencyFormat(e.target.value)
    //                  : e.target.value;
    //            }else if (type === "creditAmount") {
    //             let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
    //             e.target.value = newVal;
    //             formData.creditAmount =
    //               e.target.value === ""
    //                 ? ""
    //                 : !isNaN(e.target.value)
    //                 ? Utils.currencyFormat(e.target.value)
    //                 : e.target.value;
    //           }
    //   }
    //   this.setState({ deposits: deposits, formData }, () => {});
    // } else {
    if (type === "debitAmount") {
      let itemRows = deposits.filter((x) => x.srno == row.srno);
      if (itemRows != null && itemRows.length > 0) {
        itemRows[0].debitAmount = Utils.currencyFormat(e.target.value);
      }
    } if (type === "creditAmount") {
      let itemRows = deposits.filter((x) => x.srno == row.srno);
      if (itemRows != null && itemRows.length > 0) {
        itemRows[0].creditAmount = Utils.currencyFormat(e.target.value);
      }
    }

    this.setState({ deposits: deposits, formData }, () => { });
    // }
  };

  onAmountFocusAdditionalItems = (e, index, txtID, type: any) => {
    const { formData } = this.state;
    let deposits = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.deposits))
    );

    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "creditAmount") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      deposits[index].creditAmount = e.target.value;

      // this.setState({ deposits }, () => {
      //   $("#tblAdditionalMaterialItems")
      //     .find("input[id^='" + txtID + "']")
      //     .focus();
      //   let txtdesc = $("#tblAdditionalMaterialItems").find(
      //     "input[id^='" + txtID + "']"
      //   )[0] as any;
      //   if (txtdesc !== null && txtdesc !== undefined) {
      //     txtdesc.selectionStart = start;
      //     txtdesc.selectionEnd = end;
      //   }
      // });
    } else if (type === "debitAmount") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      deposits[index].debitAmount = e.target.value;

      this.setState({ formData }, () => {
        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblOrder").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }
  };

  scrollToBottom = () => {
    // this.parentScroll.current.scrollTo({
    //   top: this.parentScroll.current.scrollHeight,
    //   behavior: "smooth",
    // });
  };
  updatedCommentItem = () => {
    let updatedItem: any = {};
    this.setState({ isSave: true });
    updatedItem.transcationDate = this.state.formData.transcationDate;
    updatedItem.vendorName = this.state.formData.vendorName;
    updatedItem.amountTotal = this.state.totalAmount;
    return updatedItem;
  };
  CommentModalClose = () => {
    let uniqueno = this.state.formData.uniqueno;
    this.handleDiscard(uniqueno);
  };

  closeSlideOut = () => {
    this.props.closeSlideOut();
  };

  resetForm = () => {
    const bankname = "Select";
    const Defaultselected = [];
    const formData = {
      vendorid: 0,
      isCustomer: false,
      bankId: 0,
      journalEntryID: 0,
      transactionType: "journal",
      paymentMethod: "ACH",
      amount: Utils.currencyFormat(0),
      date: "",
      accountingDate: "",
      deposits: [],
    };
    const deposits = [
      {
        srno: 1,
        defaultitemname: [],
        depositID: 0,
        journalEntryID: 0,
        accountID: 0,
        depositDetails: "",
        internalNotes: "",
        amount: Utils.currencyFormat(0),
        tenantID: 0,
      },
    ];

    let custommerSelected: any = [];
    custommerSelected.customer_id = 0;
    custommerSelected.address = "";
    custommerSelected.company_name = "";
    custommerSelected.customercode = "";
    setTimeout(() => {
      if (this.customerSearch.current && this.customerSearch.current.handleSelectFromParent) {
        this.customerSearch.current.handleSelectFromParent(custommerSelected);
      }
    }, 100);


    this.setState({ bankname, Defaultselected, formData, deposits });
  };


  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }
  componentDidMount() {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    this.setState({
      createdId: storage?.user_UniqueID ?? 0,
      createdName: storage ? `${storage.firstName} ${storage.lastName}` : ""
    });

    this.getDocumentTypes();
    this.getuserdata({});
    // this.getDepartment();

    // if(this.props.Id > 0){this.getDeposits();}
    // else{ this.setState({ formData: { department: 'Select', documentType:"Select",Id:0,identifier:""} });}
  };

  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId) {
      this.closeSlideOut();
    }
  }

  getDocumentTypes = () => {
    let processdataList: any = [];
    DocumentService.GetDocListAll({})
      .then(async (result: any | null) => {
        if (result !== null) {

          const activeDocs = result.filter((element: any) => element.active == true);

          activeDocs.forEach((element: any) => {
            let item: any = {
              id: element.id,
              abb: element.identifier,
              name: element.name,
              controlled: element.controlled
            };
            processdataList.push(item);
          });

          this.setState({
            isDocumentLoad: false,
            documentList: [],

          },
            () => {
              this.setState({ documentList: processdataList, isDocumentLoad: true });

            });




        } else {
          this.setState({ isDocumentLoad: true });

        }
        resolve();
      });



  };

  getDocumentTypes1 = () => {
    let processdataList: any = [];
    const { formData } = this.state;
    DocumentService.GetDocListAll({})
      .then(async (result: any | null) => {
        if (result !== null) {

          const activeDocs = result.filter((element: any) => element.active == true);

          activeDocs.forEach((element: any) => {
            let item: any = {
              id: element.id,
              abb: element.identifier,
              name: element.name,
              controlled: element.controlled
            };
            processdataList.push(item);
          });

          this.setState({
            isDocumentLoad: false,
            documentList: [],

          },
            () => {
              const selectedDocumentType = processdataList.find(document => document.id === this.state.formData.documentType);
              formData.documentType = selectedDocumentType.name;
              formData.identifier = selectedDocumentType.identifier;
              formData.categoryId = selectedDocumentType.id;
              this.setState({ formData, documentList: processdataList, isDocumentLoad: true });

            });




        } else {
          this.setState({ isDocumentLoad: true });

        }
        resolve();
      });



  };
  getDepartment = () => {
    let processdataList: any = [];
    DocumentService.GetDepartment({})
      .then(async (result: any | null) => {
        if (result !== null) {

          result.forEach(element => {

            let item: any = {};
            item.id = element.id;
            item.name = element.departmentName;

            processdataList.push(item);
          });
          this.setState({
            departmentList: [],
            isDepartmentLoad: false
          },
            () => {

              this.setState({ departmentList: processdataList, isDepartmentLoad: true });
            });




        } else {
          this.setState({ isDepartmentLoad: true });

        }
        resolve();
      });



  };
  getuserdata = (id: any = []) => {
    let processdataList: any = [];
    UserService.GetUserMaster({})
      .then(async (result: any | null) => {
        if (result !== null) {
          // result.forEach(element => {

          //   let item: any = {};
          //   item.id = element.user_UniqueID;
          //   item.value = `${element.firstName} ${element.lastName}`;
          //   item.label = `${element.firstName} ${element.lastName}`;
          //   item.name = `${element.firstName} ${element.lastName}`;

          //   processdataList.push(item);
          //   //Typelistprocess.push(item);
          // });

          const labelSet = new Set<string>();

          result.forEach((element: any) => {
            const label = `${element.firstName} ${element.lastName}`;
            if (!labelSet.has(label)) {
              labelSet.add(label);

              processdataList.push({
                id: element.user_UniqueID,
                value: label,
                label: label,
                name: label,
              });
            }
          });

          this.setState({
            userdataList: processdataList,

          },
            () => {

              // if (this.state.formData.Id === 0 && this.state.deposits.length > 0) {
              //     const updatedDeposits = [...this.state.deposits];
              //     updatedDeposits[0].userdataList = processdataList;
              //     this.setState({
              //       deposits: updatedDeposits,
              //     });
              //   }
              if (this.props.Id > 0) { this.getDeposits(); }
              else {
                this.setState({
                  formData: { department: 'Select', documentType: "Select", Id: 0, identifier: "" },
                  userLoad: true,
                  deposits: [
                    {
                      srno: 1,
                      revision: "",
                      identifier: "",
                      description: "",
                      date: new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime)),
                      tenantID: 0,
                      createdbyName: this.state.createdName,
                      createdby: this.state.createdId,
                      approvedbyName: "Select",
                      approvedby: 0,
                      status: "Active"
                    },
                  ],
                });
              }

            });




        }
        resolve();
      });
    // .catch((error) => {

    //   reject();
    // });


  };

  getDeposits = () => {
    DocumentService.GetDocument({ id: this.state.formData.Id })
      .then(async (result: any | null) => {
        if (result != null) {
          const { formData, openAttach, openAttachIndex } = this.state;
          let { showModal, attachId } = this.state;
          const updatedDeposits = result.documentDetails.map((deposit, index) => {
            deposit.srno = index + 1;
            deposit.description = deposit.description;
            deposit.revision = deposit.revision;
            deposit.identifier = deposit.identifier;
            deposit.detailID = deposit.detailID;
            deposit.status = deposit.status;
            deposit.createdby = deposit.createdby;
            deposit.createdbyName = deposit.createdbyName;
            deposit.approvedby = deposit.approvedby;
            deposit.approvedbyName = deposit.approvedbyName;

            return deposit;
          });

          formData.documentType = result.documentType;
          formData.department = result.department;
          formData.identifier = result.identifier;
          formData.tenantId = result.tenantId;
          formData.categoryId = result.categoryId;
          let docNumber = result.docNumber;
          let stringId = result.stringId || "";

          const matchingDoc = this.state.documentList.find(
            (doc: any) => doc.id == result.categoryId
          );

          const isControlled = matchingDoc?.controlled ?? false;

          const updatedLocationList = this.state.userdataList.map((location) => ({
            ...location,
            isChecked: result.selectedIds.includes(location.id),
          }));

          if (openAttach && openAttachIndex != null) {
            const selectedDeposit = updatedDeposits[openAttachIndex];

            if (selectedDeposit) {
              showModal = true;
              attachId = selectedDeposit.id;
            }
          }

          console.log("results updatedDeposits", updatedDeposits, formData);

          this.setState({ deposits: updatedDeposits, isControlled, userdataList: updatedLocationList, formData, docNumber, stringId, userLoad: true, showModal, attachId, openAttach: false, openAttachIndex: 0 });
          this.GetUploadFileList(this.state.formData.Id, 1);

        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };



  GetUploadFileList = (uniqueNo, type) => {
    let requestlist: any = {};

    requestlist.transactionID = this.state.formData.Id > 0 ? this.state.formData.Id : uniqueNo;
    requestlist.transactionType = "document";

    // Metadata only — do not download file bytes on slideout open
    TransactionService.GetUploadFileMetadataTransaction(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = [];
          result.forEach((element, i) => {
            const key = getAttachmentCacheKey(element);
            // Rehydrate from session cache if this file was opened earlier
            if (key != null && documentFileContentCache.has(key)) {
              element.fileCode = documentFileContentCache.get(key);
            } else {
              element.fileCode = null;
            }
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            filelist.push(element);
          });
          this.setState({ savedfiles: [] }, () => {
            this.setState(
              (prevState) => ({
                savedfiles: filelist,
                isAttachmentLoading: false,
                isOpenViewer: false,
                newSelectedfiles: [],
                files: [],
                bulkSelect: true,
              }),
              () => {
                setTimeout(() => {
                  this.scrollheight.current?.getElement().scrollTo({
                    top: Number(this.state.currentScreenTop),
                    behavior: "smooth",
                  });
                }, 500);
              }
            );
          }


          );


        } else {
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
            bulkSelect: false,
          });
        }

        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({
          isOpenViewer: false,
          savedfiles: [],
          newSelectedfiles: [],
          files: [],
          bulkSelect: false,
        });
      });
  };

  /**
   * Ensures each file has fileCode loaded (from cache or API).
   * Used before opening the viewer so all appended files can render.
   */
  ensureFilesContentLoaded = async (
    files: any[],
    transactionType: string = "document"
  ): Promise<any[]> => {
    if (!files || files.length === 0) return [];

    const updated = files.map((f) => ({ ...f }));

    // Apply cache hits first
    updated.forEach((file) => {
      const key = getAttachmentCacheKey(file);
      if (!hasFileContent(file) && key != null && documentFileContentCache.has(key)) {
        file.fileCode = documentFileContentCache.get(key);
      }
    });

    const missing = updated.filter((file) => {
      if (file?.isLocalAttachment) return false;
      return !hasFileContent(file) && getAttachmentCacheKey(file) != null;
    });

    if (missing.length === 0) return updated;

    await Promise.all(
      missing.map(async (file) => {
        const key = getAttachmentCacheKey(file)!;
        try {
          const result = await TransactionService.GetUploadFileById(
            key,
            file.transactiontype || file.transactionType || transactionType
          );
          const rawCode = result?.fileCode ?? result?.FileCode;
          if (result && rawCode) {
            const dataUrl = toPreviewDataUrl(rawCode, result.name || result.Name || file.name);
            documentFileContentCache.set(key, dataUrl);
            file.fileCode = dataUrl;
            const pages = result.pageno ?? result.Pageno;
            if (pages != null) file.pageno = pages;
          }
        } catch (err) {
          console.error("Error loading file content:", key, err);
        }
      })
    );

    return updated;
  };


  handleChange = (event: any, FieldType: string, index: any) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let formData = { ...this.state.formData };

    if (FieldType === "date") {
      //   formData.OrderDate = event.target.value.trim().length > 0 ? event.target.value : "";
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.date = dateNewt;
      this.setState({ formData: formData, isStateChanged });
    } else if (FieldType === "accountingDate") {
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.accountingDate = dateNewt;
      this.setState({ formData, isStateChanged });
    } else if (FieldType === "totalamount") {

      let newVal = event.target.value == "" ? "" : Utils.removeInvaildCharFromAmount(event.target.value);
      event.target.value = newVal;
      const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
      let lenbeforePoint = 8;
      if (event.target.value.includes("-")) {
        lenbeforePoint = 9;
      }

      if (rx_live.test(event.target.value)) {
        if (event.target.value.includes(".")) {
          const timeArray = (event.target.value)?.split(".");
          if (timeArray[0].length <= lenbeforePoint && timeArray[1].length <= 2) {
            formData.amount = event.target.value;
          }
        } else {
          if (event.target.value.length <= lenbeforePoint) {
            formData.amount = event.target.value;
          }
        }
      } else if (event.target.value.includes(".") && event.target.value.length === 1) {
        formData.amount = event.target.value;

      }


      // formData.amount = event.target.value;
      this.setState({ formData });
    }

    this.setState({ formData, isStateChanged, isSpinner: false }, () => { });
  };





  handleDatePicker = (event: any, refName: any) => {
    refName.current.setOpen(true);
  };



  handleCustomerChange = (e: any) => {
    let isStateChanged = true;
    if (e.length > 0) {
      let requestlist = { ...this.state.requestlist };

      let formData = { ...this.state.formData };
      requestlist.vid = e[0].customer_id;
      formData.vendorid = e[0].customer_id;


      let options: any = [];
      let Defaultselected: any = [];


      if (e[0].customerContact == undefined) {
        let item: any = {};
        item.id = 0;
        item.name = e[0].firstname;
        options.push(item);
        let objData: any = {};
        objData.id = 0;

        objData.name = e[0].firstname;
        Defaultselected.push(objData);
      }
      else {
        e[0].customerContact.forEach(element => {

          let item: any = {};
          item.id = element.id;
          item.name = element.firstname;
          options.push(item);

        });


        let defaultname: any = e[0].customerContact.filter(
          (x) => x.isDefault == true
        );


        if (defaultname.length > 0) {
          let objData: any = {};
          objData.id = defaultname[0].firstname;
          objData.name = defaultname[0].firstname;
          Defaultselected.push(objData);
        };

      }

      this.setState({
        formData,
        Defaultselected: Defaultselected,
        options: options,
        isStateChanged: isStateChanged
      });




      let txtID = "txtOrderDate";
      // setTimeout(() => {
      //  // this.trDate.current.setOpen(true);
      // //  this.trpoDate.current.setOpen(true);
      //  // $("input[id^='" + txtID + "']").focus();
      // }, 50);


      // if (controlID === "txtExternalOrderDate") {
      //   this.trpoDate.current.setOpen(true);
      //   }
    }
  };

  handleVendorChange = (e: any) => {
    let isStateChanged = true;
    let formData = { ...this.state.formData };
    if (e.length > 0) {
      this.setState({
        CustomerName: e[0].company_name,
        address: e[0].address,
        customercode: e[0].vendorcode,
        isStateChanged: isStateChanged,
      });
      this.state.formData.vendorid = e[0].vendor_id;

      let objData: any = {};
      let Defaultselected: any = [];
      let defaultname: any = e[0].vendorContact.filter(
        (x) => x.isDefault == true
      );
      if (defaultname.length > 0) {
        objData.id = defaultname[0].firstname;
        objData.name = defaultname[0].firstname;
        Defaultselected.push(objData);
      }

      this.setState({
        Defaultselected: Defaultselected,
      });

      // let txtID = "txtaccount";
      // setTimeout(() => {
      //   this.accRef.current.setOpen(true);
      //   $("input[id^='" + txtID + "']").focus();
      // }, 50);
    }
  };

  handleDiscard(postID) {
    this.setState({ isStateChanged: false }, () => {
      this.closeSlideOut();
    });
  }

  handleEdit() {
    this.setState({
      isStateChanged: true,
      editMode: true,
      showOptionSelect: true,
    });
  }

  onTAB = (control, rowIndex1, event) => {
    let controlID = control.split("-")[0];
    let rowIndex = Number(rowIndex1);

    if (event.key.toLowerCase() === "enter") {
      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "txtDueDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    if (event.key.toLowerCase() === "tab") {
      let ChecktxtID = "partname" + rowIndex + "ddl";

      if (controlID === "lineDescription") {
        let txtID = "txtdebitAmount" + rowIndex + "txt";
        setTimeout(() => {
          const inputField = $("input[id^='" + txtID + "']");
          inputField.focus();
          inputField.select();
        }, 50);
      }

      if (controlID === "accountingDate") {
        console.log("oooo");
        let txtID = "txttotalamount";
        setTimeout(() => {
          const inputField = $("input[id^='" + txtID + "']");
          inputField.focus();
          inputField.select();
        }, 50);
      }


      if (controlID === "debitAmount") {
        let txtID = "txtcreditAmount" + rowIndex + "txt";
        setTimeout(() => {
          const inputField = $("input[id^='" + txtID + "']");
          inputField.focus();
          inputField.select();
        }, 50);
      }

      if (controlID === "itemname") {
        let txtID = "txtglcode" + rowIndex + "txt";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }

      if (controlID === "txtduedate") {
        let txtID = "txtdescription" + rowIndex + "txt";

        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
      }

      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    // if (event.key.toLowerCase() === "backspace" && controlID !== "qty") {
    //   let controlID = control.split("-")[0];
    //   let rowIndex = Number(rowIndex1);
    //   let orderData = Object.assign(
    //     [],
    //     JSON.parse(JSON.stringify(this.state.orderData))
    //   );
    //   let defaultPartname: any = [];
    //   let productList = Object.assign(
    //     [],
    //     JSON.parse(JSON.stringify(this.state.productList))
    //   );

    //   orderData[rowIndex].partname = event.target.value;
    //   orderData[rowIndex].productid = 0;
    //   orderData[rowIndex].partNo = "";
    //   orderData[rowIndex].unitPrice = 0;
    //   orderData[rowIndex].unit = "";
    //   orderData[rowIndex].jobDesc = "";

    //   let objPartname: any = {};
    //   objPartname.partname = event.target.value;
    //   objPartname.label = event.target.value;
    //   objPartname.id = 0;
    //   objPartname.partno = "";

    //   objPartname.tenantid = 0;
    //   objPartname.unit = "";
    //   objPartname.unitPrice = 0;
    //   objPartname.noofday = null;
    //   objPartname.jobDesc = "";
    //   defaultPartname.push(objPartname);
    //   productList.push(objPartname);

    //   //element.defaultPartname = defaultPartname;
    //   orderData[rowIndex].defaultPartname = defaultPartname;

    //   this.setState({ orderData, defaultPartname, productList }, () => {
    //     let txtID =
    //       "rbt-input-main form-control rbt-input partname" + rowIndex + "ddl";
    //     $("#tblOrder")
    //       .find("input[class^='" + txtID + "']")
    //       .focus();
    //   });

    //   let txtID =
    //     "rbt-input-main form-control rbt-input partname" + rowIndex + "ddl";

    //   let tvalue =
    //     event.target.value.trim().length > 0 ? event.target.value : "";
    //   if (tvalue === "") {
    //     setTimeout(() => {
    //       $("input[class^='" + txtID + "']").focus();
    //     }, 50);
    //   }
    // }
  };

  HidecloseSlideOut() {
    this.props.closeSlideOut();
    this.setState({ isSaveSpinner: false });
  }

  Hidespinner() {
    this.setState({ isSpinner: false });
  }




  saveDeposit = (showModal: boolean, files?: any) => {
    this.setState({ unsave: false });
    console.log("formdata", this.state.deposits, this.state.formData);
    // return;
    let isFormValid = true;
    let request: any = {};
    const { formData, isControlled } = this.state;
    let deposits = this.state.deposits;

    if (this.state.formData.documentType === "Select") {
      toast.error("Please select document type.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });

      return false;
    }

    // if (this.state.formData.department === "Select") {
    //   toast.error("Please select department type.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });

    //   return false;
    // }


    const invalidDeposit = this.state.deposits.some((deposit, index) => {
      return deposit.revision.trim() === "" || deposit.approvedby === 0 || deposit.createdby === 0;
    });


    if (invalidDeposit && isControlled) {
      toast.error("Please enter the missing fields.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });

      return false;
    }

    const noActiveDeposit = !this.state.deposits.some(deposit => deposit.status === "Active");
    if (noActiveDeposit) {
      toast.error("There is no active record.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      return false;

    }

    //   if (Number.isInteger(this.state.formData.department)) {
    //   const selectedDepartment = this.state.departmentList.find(department => department.id === this.state.formData.department);
    //  this.state.formData.department = selectedDepartment ? selectedDepartment.name : '';
    //   }
    if (Number.isInteger(this.state.formData.documentType)) {
      const selectedDocumentType = this.state.documentList.find(document => document.id === this.state.formData.documentType);
      this.state.formData.documentType = selectedDocumentType ? selectedDocumentType.name : '';
    }


    const filesToUpload = Array.isArray(files) && files.length > 0
      ? files
      : Array.isArray(this.state.newSelectfiles) && this.state.newSelectfiles.length > 0
        ? this.state.newSelectfiles.map((file: any) => file?.sourceFile || file)
        : [];

    this.state.formData.documentDetails = this.state.deposits.map(deposit => {
      const depositDate = new Date(deposit.date);
      const currentDate = new Date();
      depositDate.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), currentDate.getMilliseconds());

      return {
        ...deposit,
        date: depositDate
      };
    });


    this.setState({ isSpinner: true });
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    // request.date= moment(this.state.formData.date).local().format();

    if (filesToUpload.length > 0) {
      const transformedDeposits = this.state.deposits.map(deposit => {
        const date = moment(deposit.date).local().format();
        const apiFormattedDate = `\/Date(${new Date(date).getTime()})\/`;

        return {
          ...deposit,
          date: apiFormattedDate,
          Id: deposit.id,
        };
      });

      this.state.formData.documentDetails = transformedDeposits;
      request = Object.assign({}, JSON.parse(JSON.stringify(formData)));
    }



    request.deletedRowIds = this.state.deletedRowIds || [];

    if (isFormValid) {
      console.log("req save", request);
      // return;
      this.setState({ ispopupshow: false });
      debugger;
      if (filesToUpload.length > 0) {
        DocumentService.SaveDocumentFile(request, filesToUpload)
          .then(async (result: any | null) => {
            if (result.result !== null && result.result.uploadFileList1) {

              let message = "File has been uploaded.";
              toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });

              formData.Id = this.state.formData.Id > 0 ? this.state.formData.Id : result.result.id;
              this.setState(
                {
                  isSpinner: false,
                  isStateChanged: false,
                  formData,
                  newSelectfiles: [],
                  deletedRowIds: [],
                },
                () => {
                  this.getDeposits();
                  this.GetUploadFileList(this.state.formData.Id > 0 ? this.state.formData.Id : result.result.id, 1);
                });
            }
            else {
              toast.error(result.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
              this.setState({
                isSpinner: false,
                isStateChanged: false,
              });
            }

            resolve();
          })
          .catch((error) => {
            this.setState({ isdefaultColDisabled: false, isSpinner: false });
          });
      } else {
        DocumentService.SaveDocuments(request)
          .then(async (result: any | null) => {
            if (result.result !== null) {
              if (
                this.state.formData.Id === 0 ||
                this.state.formData.Id == undefined
              ) {
                toast.success("Document has been created", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "OrderSlideout",
                });
              } else {
                let message = "Document has been updated.";
                toast.success(message, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "OrderSlideout",
                });
              }
              // this.closeSlideOut();
              formData.Id = this.state.formData.Id > 0 ? this.state.formData.Id : result.result.id;
              const openAttach = showModal;
              this.setState(
                {
                  isSpinner: false,
                  isStateChanged: false,
                  formData, openAttach,
                  deletedRowIds: [],
                },
                () => {
                  this.getDeposits();
                  this.GetUploadFileList(this.state.formData.Id > 0 ? this.state.formData.Id : result.result.id, 1);
                });
            } else {
              toast.error(result.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
              this.setState({
                isSpinner: false,
                isStateChanged: false,
              });
            }
            resolve();
          })
          .catch((error) => {
            this.setState({ isdefaultColDisabled: false, isSpinner: false });
            reject();
          });
      }
    }
  };

  deleteVendorOrder = () => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.vendororderid = this.state.vendororderid;

    VendorService.DeleteVendorOrder(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.closeSlideOut();

          toast.success("Vendor Order has been deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });

          this.setState({ isSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      //this.setState({ showSlideout: true ,orderid:row.orderID
      // });
    },
  };


  updateMultiSelectItem = (selectedItems: any[]) => {
    const { formData } = this.state;

    const selectedValues = selectedItems.map((item) => parseInt(item.id, 10));

    this.setState({
      formData: {
        ...formData,
        selectedIds: selectedValues,
      },
      isStateChanged: true
    });
  };



  handleClose = () => {
    this.setState({ showAfterSaveModelPopup: false, isSpinner: false });
  };

  handleNewRow = () => {
    let newRow: any = {
      srno: 1,
      revision: "",
      identifier: "",
      date: new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime)),
      createdbyName: this.state.createdName,
      createdby: this.state.createdId,
      approvedbyName: "Select",
      description: "",
      approvedby: 0,
      tenantID: 0,
      status: "Active"
    };
    let isStateChanged = true;
    let deposits: any = [];
    deposits = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.deposits))
    );

    const lastDeposit = deposits[0];

    if (
      lastDeposit &&
      (lastDeposit.revision === "" ||
        lastDeposit.approvedby === 0 ||
        lastDeposit.createdby === 0)
    ) {
      toast.error("Please enter the missing fields.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      return;
    }

    if (lastDeposit) {
      newRow.identifier = lastDeposit.identifier;
      newRow.description = lastDeposit.description;
    }

    deposits.forEach((deposit: any) => {
      deposit.srno += 1;
      deposit.status = "Obsolete";
    });

    let len = deposits.length;
    const maxSrno = deposits.length > 0
      ? Math.max(...deposits.map(deposit => deposit.srno))
      : 0;

    // newRow.srno = maxSrno + 1;
    // deposits.push(newRow);

    deposits.unshift(newRow);

    this.setState({ deposits: [] }, () => {
      this.setState({
        deposits: deposits,
        isStateChanged,
      });
    });
  };

  handleDeleteRow = (row: any, rowIndex: number) => {
    confirmAlert({
      title: "Delete Row",
      message:
        "Are you sure you want to delete this row? This action cannot be undone on saving. Any files attached to this row will also be permanently deleted.",
      buttons: [
        {
          label: "Delete",
          onClick: () => {
            let deposits = [...this.state.deposits];
            let deletedRowIds = [...(this.state.deletedRowIds || [])];

            let rowId = row.Id || row.id || 0;
            if (rowId > 0) {
              deletedRowIds.push(rowId);
            }

            deposits.splice(rowIndex, 1);
            deposits = deposits.map((item: any, idx: number) => ({
              ...item,
              srno: idx + 1,
            }));

            this.setState({
              deposits,
              deletedRowIds,
              isStateChanged: true,
            });
          },
        },
        {
          label: "Cancel",
          onClick: () => { },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    });
  };

  handleAttachmentClick = (row: any, rowIndex: any) => {
    if (this.state.formData.Id === 0 || !row.id) { this.setState({ unsave: true, openAttachIndex: rowIndex }); }
    else { this.setState({ showModal: true, attachId: row.id }); }
  };


  handleOpenClick = (row: any, rowIndex: any) => {
    let requestlist: any = {};
    this.setState({ isSpinnerdoc: true });

    requestlist.transactionID = row.id;
    requestlist.transactionType = "documentDetails";

    // Metadata first, then load content for this detail's files before opening viewer
    TransactionService.GetUploadFileMetadataTransaction(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = result.map((element: any) => {
            const key = getAttachmentCacheKey(element);
            if (key != null && documentFileContentCache.has(key)) {
              element.fileCode = documentFileContentCache.get(key);
            } else {
              element.fileCode = null;
            }
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            return element;
          });

          filelist = await this.ensureFilesContentLoaded(filelist, "documentDetails");

          this.setState({ savedfiles: [] }, () => {
            this.setState(
              (prevState) => ({
                savedfilesSeparate: filelist,
                isAttachmentLoading: false,
                isOpenViewer: false,
                bulkSelect: true,
              }),
              () => {
                setTimeout(() => {
                  this.scrollheight.current?.getElement().scrollTo({
                    top: Number(this.state.currentScreenTop),
                    behavior: "smooth",
                  });
                }, 500);
                this.OpenViewerSeparate();
              }
            );
          });
        } else {
          toast.error("No File to view", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          this.setState({ isSpinnerdoc: false });
        }
        resolve();
      })
      .catch((error) => {
        reject();
        toast.error("No File to view", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        this.setState({ isSpinnerdoc: false });
      });
  };

  OpenViewerSeparate() {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    const currentFile =
      this.state.savedfilesSeparate.length > 0
        ? this.state.savedfilesSeparate[0]
        : this.state.newSelectfiles[0];
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        singleView: false,
        fileSelect: currentFile,
        isMapped: "No",
        isExtractOption: false,
        isextractShow: this.isPdfFile(currentFile),
        selectedChk: [],
        chkIds: [],
        separateView: true,
      }),
      () => {
        this.setState({ defaultView: "doc-view" });
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec, isSpinnerdoc: false });
          }, 100);
        }
      }
    );
  }

  closeModal = () => {
    this.setState({ showModal: false, attachId: 0 });
  };




  handleSelectedItem = (control: any, id: any) => {
    if (this != undefined) {
      let isStateChanged = true;

      let controlID = Number(control.split("_")[0]);
      let rowIndex = Number(control.split("_")[1]);

      let defaultitemname: any = [];




      let deposits = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.deposits))
      );

      if (controlID === 2) {

        let rowIndex = Number(control.split('_')[1]);
        let filterRow = this.state.userdataList.filter(x => x.id === id);

        deposits[rowIndex].createdbyName = filterRow[0].name;
        deposits[rowIndex].createdby = filterRow[0].id;

        this.setState({ deposits: [] }, () => {
          this.setState({ deposits, ischanged: 1, isStateChanged: true }, () => {
            let txtID = 'ddlprocess-' + (rowIndex) + "ddl";
            $("#tbltemplate").find("button[id^='" + txtID + "']").focus();
          });
        });

      } else if (controlID === 3) {

        let rowIndex = Number(control.split('_')[1]);
        let filterRow = this.state.userdataList.filter(x => x.id === id);

        deposits[rowIndex].approvedbyName = filterRow[0].name;
        deposits[rowIndex].approvedby = filterRow[0].id;

        this.setState({ deposits: [] }, () => {
          this.setState({ deposits, ischanged: 1, isStateChanged: true }, () => {
            let txtID = 'ddlprocess-' + (rowIndex) + "ddl";
            $("#tbltemplate").find("button[id^='" + txtID + "']").focus();
          });
        });

      } else if (controlID === 4) {

        let rowIndex = Number(control.split('_')[1]);
        let filterRow = this.state.statusList.filter(x => x.id === id);

        if (filterRow[0].name === "Active") {
          deposits.forEach((deposit, index) => {
            if (index !== rowIndex) {
              deposit.status = "Obsolete";
            }
          });
        }

        deposits[rowIndex].status = filterRow[0].name;

        this.setState({ deposits: [] }, () => {
          this.setState({ deposits, ischanged: 1, isStateChanged: true }, () => {
            let txtID = 'ddlprocess-' + (rowIndex) + "ddl";
            $("#tbltemplate").find("button[id^='" + txtID + "']").focus();
          });
        });

      }
    }
  };

  handleOutsideClickForAdditionalItems = (rowIndex: any, e: any) => {
    let btnId = "itemname" + rowIndex + "btn";
    let id = "itemname" + rowIndex + "ddl";
    let relatedTargetID = e.relatedTarget?.id;

    let defaultitemname: any = [];
    let coaList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.coaList))
    );

    let deposits = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.deposits))
    );


    if (e.target.value != "") {
      let objPartname: any = {};
      objPartname.itemName = e.target.value;
      objPartname.label = e.target.value;
      objPartname.id = 0;
      objPartname.tenantid = 0;
      defaultitemname.push(objPartname);
      coaList.push(objPartname);

      deposits[rowIndex].defaultitemname = defaultitemname;

      this.setState(
        { deposits, defaultitemname, coaList },
        () => { }
      );
    } else {
      this.setState({ additionalMaterialItems: [] }, () =>
        this.setState({ deposits }, () => { })
      );
    }

    $("#tblAdditionalMaterialItems")
      .find("button[id^='" + btnId + "']")
      .css("display", "none");
    $("#tblAdditionalMaterialItems")
      .find("div[id^='" + id + "']")
      .css("display", "none");
  };

  itemsSelected = (Chieldstate: any) => {
    let data = Object.assign([], JSON.parse(JSON.stringify(Chieldstate)));
    this.setState({ selectedItems: data, isChange: true });
  };


  onFileChange = (event: any, mode) => {

    // 
    let newfiles: any = [];
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        let fileRow = event.target.files[i];
        newfiles.push(fileRow);
      }
      this.onDrop(newfiles, mode);
      let fileList = document.getElementById("formControlsFile") as any;
      fileList.value = "";
    }
  };

  onDrop = (filelist: any, mode: any) => {
    const sizeLimit = this.state.fileSize;
    const maxMb = Number(sizeLimit) / (1024 * 1024);

    let files: any[] = [];
    let newFiles: any[] = [];

    let oversize = false;
    let invalidFile = false;

    const blockedExtensions = [
      "exe", "dll", "bat", "cmd", "sh", "msi", "sys",
      "com", "scr", "ps1", "vbs", "js", "jar", "reg"
    ];

    filelist.forEach((file) => {
      const ext = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();

      if (file.size > sizeLimit) {
        oversize = true;
        return;
      }

      if (blockedExtensions.includes(ext)) {
        invalidFile = true;
        return;
      }

      files.push(file);
      newFiles.push(file);
    });

    if (oversize) {
      toast.error(`One or more files are greater than ${maxMb} MB.`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
    }

    if (invalidFile && !oversize) {
      toast.error(
        filelist.length === 1
          ? "This file type is not supported."
          : "Some files are not supported.",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        }
      );
    }

    const draftFiles = files.map((file: File, index: number) => this.createLocalAttachmentPreview(file, index));

    const isExistingRecord = Number(this.state.formData?.Id) > 0;

    this.setState(
      {
        files,
        newSelectfiles: draftFiles,
        isSave: true,
        ispopupshow: false,
        isSpinner: isExistingRecord,
        isStateChanged: true,
      },
      () => {
        if (isExistingRecord && files.length > 0) {
          this.saveDeposit(false, files);
        }
      }
    );
  };

  createLocalAttachmentPreview = (file: File, index: number) => {
    const localId = Date.now() + index;
    return {
      id: localId,
      fileUniqueno: localId,
      name: file.name,
      fileName: file.name,
      fileCode: URL.createObjectURL(file),
      fileContentType: file.type || "application/pdf",
      fileSize: file.size,
      sourceFile: file,
      isLocalAttachment: true,
    };
  };

  onDropold = (filelist: any, mode: any) => {
    let size = this.state.fileSize; //5242880//5MB
    let newfiles: any = [];
    let files: any = [];
    let isReturn = true;
    let filestext = "";
    let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
    filelist.forEach((element) => {
      if (element.size > size) {
        filestext = filestext + element.name + ",";
        isReturn = false;
      }
    });

    if (!isReturn) {
      let msg = "One or more files are greater than " + filesizeval + "MB.";
      toast.error(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
    }
    let isInvalidFile = false;
    filelist.forEach((element) => {
      if (
        (element.name
          .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
          .toLowerCase() === "pdf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "doc" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "docx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xls" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xlsx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "csv" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "txt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "bmp" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "tif" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "ppt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pptx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "rtf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpeg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "png" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "msg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "eml") &&
        element.size <= size
      ) {
        newfiles.push(element);
        files.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    if (isInvalidFile && isReturn) {
      let msg = "";
      if (filelist.length === 1) {
        msg = "This file type is not supported.";
      } else {
        msg = "Some files are not supported.";
      }
      toast.error(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
    }

    this.setState(
      {
        files,
        newSelectfiles: newfiles,
        isSave: true,
        ispopupshow: false,
        isSpinner: true,
      },
      () => {
        if (files.length > 0) {
          this.saveDeposit(false, files);
        }
      }
    );
  };


  handleFileDelete(newfiles, file) {
    let request: any = {};
    request.fileUniqueno = file.fileUniqueno;
    request.transactionid = this.state.formData.Id;
    request.transactiontype = "document";

    this.handleDeleteFileFromDb(request, newfiles, 2);
  }
  handleDeleteFileFromDb(request, newfiles, id) {
    TransactionService.DeleteUploadedFileTransaction(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: false, isOpenViewer: false });
          this.getDeposits();

        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  isDeleteattachment(file) {
    invalidateDocumentFileCache(file);

    if (this.state.formData.Id === 0 || file?.isLocalAttachment) {
      if (file?.fileCode && typeof file.fileCode === "string" && file.fileCode.startsWith("blob:")) {
        URL.revokeObjectURL(file.fileCode);
      }

      const updatedLocalFiles = (this.state.newSelectfiles || []).filter(
        (item: any) => Number(item.id) !== Number(file.id)
      );

      this.setState({
        newSelectfiles: updatedLocalFiles,
        isStateChanged: true,
      });
      return;
    }

    let newfiles: any = [];
    this.state.savedfiles.forEach((element, idx) => {
      if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
        newfiles.push(element);
      }
    });
    this.handleFileDelete(newfiles, file);
  }

  downloadTranactionFile = (file: any) => {
     this.setState({ isSaveSpinner: true });
    TransactionService.DownloadTransactionFile(file)
      .then(async (result: any | null) => {
         this.setState({ isSaveSpinner: false });
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ isSaveSpinner: false });
      });
  };

  handleSelectFileUpload = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      let request: any = {};
      request = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.state.formData))
      );
      let masg = "";

      masg = "Are you sure you want to delete this Attachment?";

      confirmAlert({
        title: "Delete Attachment",

        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.isDeleteattachment(file),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],

        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else if (eventKey === "download") {
      this.downloadTranactionFile(file);
    } else if (eventKey === "view") {
      console.log("file index", file, index);
      this.OpenViewerSingle(index);
    }
  };
  hideBulkselect() {
    this.setState({
      bulkSelect: false,
      chkIds: [],
      selectedChk: [],
      isMapped: "No",
    });
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.hideBulkSelect();
    }
  }
  OpenViewer = async () => {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }

    // Closing viewer — no download needed
    if (this.state.isOpenViewer) {
      this.setState({ isOpenViewer: false, separateView: false, singleView: false });
      return;
    }

    const savedfiles = this.state.savedfiles || [];
    const localFiles = this.state.newSelectfiles || [];
    const needsDownload = savedfiles.some((f: any) => !hasFileContent(f) && !f?.isLocalAttachment);

    if (needsDownload) {
      this.setState({ isSpinnerdoc: true });
      try {
        const loaded = await this.ensureFilesContentLoaded(savedfiles, "document");
        this.setState({ savedfiles: loaded, isSpinnerdoc: false }, () => {
          this.openViewerWithFiles(loaded, localFiles);
        });
      } catch (err) {
        this.setState({ isSpinnerdoc: false });
        toast.error("Error loading files for preview", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
      }
    } else {
      this.openViewerWithFiles(savedfiles, localFiles);
    }
  };

  openViewerWithFiles = (savedfiles: any[], localFiles: any[]) => {
    const currentFile =
      savedfiles.length > 0 ? savedfiles[0] : localFiles[0];
    this.setState(
      {
        isOpenViewer: true,
        singleView: false,
        separateView: false,
        fileSelect: currentFile,
        isMapped: "No",
        isExtractOption: false,
        isextractShow: this.isPdfFile(currentFile),
        selectedChk: [],
        chkIds: [],
        defaultView: "doc-view",
      },
      () => {
        setTimeout(() => {
          const innerWidthSec = this.scrollheight.current
            ?.getElement()
            ?.getBoundingClientRect().height;
          if (innerWidthSec) {
            this.setState({ scrollAreaHeight: innerWidthSec });
          }
        }, 100);
      }
    );
  };

  OpenViewerSingle = async (index: any) => {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }

    if (this.state.isOpenViewer) {
      this.setState({ isOpenViewer: false, singleView: false });
      return;
    }

    let currentFile = this.state.savedfiles[index];
    if (!currentFile) return;

    if (!hasFileContent(currentFile) && !currentFile?.isLocalAttachment) {
      this.setState({ isSpinnerdoc: true });
      try {
        const loaded = await this.ensureFilesContentLoaded([currentFile], "document");
        currentFile = loaded[0];
        const savedfiles = [...this.state.savedfiles];
        savedfiles[index] = currentFile;
        this.setState({ savedfiles, isSpinnerdoc: false });
      } catch (err) {
        this.setState({ isSpinnerdoc: false });
        toast.error("Error loading file for preview", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        return;
      }
    }

    this.setState(
      {
        isOpenViewer: true,
        singleView: true,
        separateView: false,
        singleViewFiles: [currentFile],
        fileSelect: currentFile,
        isMapped: "No",
        isExtractOption: false,
        isextractShow: this.isPdfFile(currentFile),
        selectedChk: [],
        chkIds: [],
        defaultView: "doc-view",
      },
      () => {
        setTimeout(() => {
          const innerWidthSec = this.scrollheight.current
            ?.getElement()
            ?.getBoundingClientRect().height;
          if (innerWidthSec) {
            this.setState({ scrollAreaHeight: innerWidthSec });
          }
        }, 100);
      }
    );
  };

  isPdfFile = (file: any) => {
    const fileName = (file?.name || file?.fileName || "").toString().toLowerCase();
    const fileCode = (file?.fileCode || "").toString().toLowerCase();
    return fileName.endsWith(".pdf") || fileCode.startsWith("data:application/pdf");
  };

  getPageNoFromSelectionId = (selectedId: any) => {
    const rawId = (selectedId || "").toString().replace("custom_", "");
    const pageIndex = Number(rawId.split("_")[1]);
    return Number.isNaN(pageIndex) ? undefined : pageIndex + 1;
  };

  handleUpdatedFile = () => {
    const selectedFiles = Array.isArray(this.state.selectedChk)
      ? this.state.selectedChk
      : [];

    return selectedFiles.filter(
      (item: any, index: number, self: any[]) =>
        item?.id &&
        index ===
        self.findIndex((entry: any) => {
          const itemPageNo = item.pageNo ?? this.getPageNoFromSelectionId(item.id);
          const entryPageNo = entry.pageNo ?? this.getPageNoFromSelectionId(entry.id);
          return Number(entry.fileNo) === Number(item.fileNo) && Number(entryPageNo) === Number(itemPageNo);
        })
    );
  };

  handleFileCheckBox = (event, files, fileNo, selectedId, type) => {
    const checked = !!event?.target?.checked;

    this.setState((prevState) => {
      let selectedChk = Array.isArray(prevState.selectedChk)
        ? [...prevState.selectedChk]
        : [];

      if (type === "bulkSelect" || type === "All") {
        const targetFileNos =
          Number(fileNo) === 0
            ? Array.from(new Set((files || []).map((file: any) => file.fileNo)))
            : [fileNo];

        selectedChk = selectedChk.filter(
          (item: any) =>
            !targetFileNos.some(
              (targetFileNo) => Number(item.fileNo) === Number(targetFileNo)
            )
        );

        if (checked) {
          targetFileNos.forEach((targetFileNo) => {
            const targetFile = (files || []).find(
              (file: any) => Number(file.fileNo) === Number(targetFileNo)
            );
            const totalPages = Number(targetFile?.totalpage || 0);
            for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
              const pageId = `custom_${targetFileNo}_${pageIndex}`;
              if (!selectedChk.some((item: any) => item.id === pageId)) {
                selectedChk.push({
                  id: pageId,
                  fileNo: targetFileNo,
                  pageNo: pageIndex + 1,
                });
              }
            }
          });
        }

        const dedupedSelectedChk = selectedChk.filter(
          (item: any, index: number, self: any[]) => {
            const itemPageNo = item.pageNo ?? this.getPageNoFromSelectionId(item.id);
            return (
              item?.id &&
              index ===
              self.findIndex((entry: any) => {
                const entryPageNo = entry.pageNo ?? this.getPageNoFromSelectionId(entry.id);
                return Number(entry.fileNo) === Number(item.fileNo) && Number(entryPageNo) === Number(itemPageNo);
              })
            );
          }
        );

        return { selectedChk: dedupedSelectedChk, chkIds: dedupedSelectedChk };
      }

      if (!selectedId) {
        return null;
      }

      if (checked) {
        const exists = selectedChk.some((item: any) => item.id === selectedId);
        if (!exists) {
          const rawId = (selectedId || "").toString().replace("custom_", "");
          const pageIndex = Number(rawId.split("_")[1]);
          selectedChk.push({
            id: selectedId,
            fileNo,
            pageNo: Number.isNaN(pageIndex) ? undefined : pageIndex + 1,
          });
        }
      } else {
        selectedChk = selectedChk.filter((item: any) => item.id !== selectedId);
      }

      const dedupedSelectedChk = selectedChk.filter(
        (item: any, index: number, self: any[]) => {
          const itemPageNo = item.pageNo ?? this.getPageNoFromSelectionId(item.id);
          return (
            item?.id &&
            index ===
            self.findIndex((entry: any) => {
              const entryPageNo = entry.pageNo ?? this.getPageNoFromSelectionId(entry.id);
              return Number(entry.fileNo) === Number(item.fileNo) && Number(entryPageNo) === Number(itemPageNo);
            })
          );
        }
      );

      return { selectedChk: dedupedSelectedChk, chkIds: dedupedSelectedChk };
    });
  };

  getCurrentViewerFile = () => {
    const viewerFiles = this.state.singleView
      ? this.state.singleViewFiles
      : this.state.separateView
        ? this.state.savedfilesSeparate
        : [...(this.state.savedfiles || []), ...(this.state.newSelectfiles || [])];

    return viewerFiles && viewerFiles.length > 0 ? viewerFiles : null;
  };

  base64ToFile1(base64: string, fileName: string, contentType: string): File {
    const base64Data = base64.includes(",") ? base64.split(",").pop() || "" : base64;
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    return new File([blob], fileName, { type: contentType });
  }

  buildSelectedPagesPdfFromSelections = async (
    fileSelections: Array<{ sourceFile: File; selectedPages: number[] }>
  ) => {
    let outputDoc: any = null;
    let outputPageIndex = 0;
    const firstFileName = fileSelections[0]?.sourceFile?.name || "document.pdf";

    for (const selection of fileSelections) {
      const arrayBuffer = await selection.sourceFile.arrayBuffer();
      const loadingTask = pdfjs.getDocument({ data: arrayBuffer });
      const pdfDocument = await loadingTask.promise;
      const pagesToRender =
        selection.selectedPages.length > 0
          ? selection.selectedPages
          : Array.from({ length: pdfDocument.numPages }, (_item, index) => index + 1);

      for (const pageNumber of pagesToRender) {
        const page = await pdfDocument.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        if (!context) {
          throw new Error("Unable to render selected PDF pages.");
        }

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
          canvasContext: context,
          viewport,
        }).promise;

        const imageData = canvas.toDataURL("image/jpeg", 1.0);
        const orientation = viewport.width >= viewport.height ? "landscape" : "portrait";
        const pageWidth = Math.ceil(viewport.width);
        const pageHeight = Math.ceil(viewport.height);

        if (!outputDoc) {
          outputDoc = new jsPDF({
            orientation,
            unit: "px",
            format: [pageWidth, pageHeight],
          });
        } else {
          outputDoc.addPage([pageWidth, pageHeight], orientation);
        }

        outputPageIndex += 1;
        outputDoc.setPage(outputPageIndex);
        outputDoc.addImage(imageData, "JPEG", 0, 0, pageWidth, pageHeight);
      }
    }

    if (!outputDoc) {
      return null;
    }

    const pdfBlob = outputDoc.output("blob");
    const fileName = fileSelections.length > 1 ? "selected-document-pages.pdf" : firstFileName;
    return new File([pdfBlob], fileName, {
      type: "application/pdf",
    });
  };

  getPdfFileForExtraction = (file: any): File | null => {
    if (!file) {
      return null;
    }

    if (file.sourceFile instanceof File) {
      return file.sourceFile;
    }

    const pdfData = file.fileData || file.fileCode;
    if (pdfData) {
      const fileName = file.filename || file.fileName || file.name || "document.pdf";
      const contentType = file.fileContentType || "application/pdf";
      return this.base64ToFile1(pdfData, fileName, contentType);
    }

    return null;
  };

  getSelectedPagesForCurrentFile = () => {
    const files = this.getCurrentViewerFile();
    if (!files || files.length === 0) {
      return [];
    }

    return files.map((file: any, fileIndex: number) => {
      const fileNo = Number(file.fileUniqueno ?? file.fileNo ?? file.id ?? fileIndex);
      const selectedPages = (this.state.selectedChk || [])
        .filter((selected: any) => {
          const selectedFileNo = Number(selected.fileNo);
          const selectedId = (selected.id || "").toString();
          return (
            selectedFileNo === fileNo ||
            selectedId.includes(`_${fileNo}_`) ||
            selectedId.startsWith(`custom_${fileNo}_`)
          );
        })
        .map((selected: any) => selected.pageNo ?? this.getPageNoFromSelectionId(selected.id))
        .filter((pageNo: any) => Number.isFinite(Number(pageNo)));

      return {
        file,
        fileNo,
        selectedPages,
      };
    });
  };

  getPdfExtractionFile = async () => {
    const currentFiles = this.getCurrentViewerFile() || (this.state.fileSelect ? [this.state.fileSelect] : []);
    const selectedFilePages = this.getSelectedPagesForCurrentFile();
    const selectedFileNos = selectedFilePages
      .filter((item: any) => item.selectedPages.length > 0)
      .map((item: any) => Number(item.fileNo));
    const shouldUseSelectedPages = selectedFileNos.length > 0;
    const extractionSelections = currentFiles
      .filter((file: any, index: number) => {
        const fileNo = Number(file.fileUniqueno ?? file.fileNo ?? file.id ?? index);
        return !shouldUseSelectedPages || selectedFileNos.includes(fileNo);
      })
      .map((file: any, index: number) => {
        const fileNo = Number(file.fileUniqueno ?? file.fileNo ?? file.id ?? index);
        const sourceFile = this.getPdfFileForExtraction(file);
        const selectedPages =
          selectedFilePages.find((item: any) => Number(item.fileNo) === fileNo)?.selectedPages || [];

        return {
          sourceFile,
          selectedPages,
        };
      })
      .filter((item: any) => item.sourceFile);

    if (extractionSelections.length === 0) {
      toast.error("Please select at least one PDF page to extract.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      return null;
    }

    if (extractionSelections.length === 1 && extractionSelections[0].selectedPages.length === 0) {
      return extractionSelections[0].sourceFile;
    }

    return this.buildSelectedPagesPdfFromSelections(
      extractionSelections as Array<{ sourceFile: File; selectedPages: number[] }>
    );
  };

  hasExistingDocumentLineItems = () => {
    return (
      Array.isArray(this.state.deposits) &&
      this.state.deposits.some((item: any) =>
        !!item?.description ||
        !!item?.revision ||
        !!item?.identifier
      )
    );
  };

  buildDocumentRowsFromDrawingExtraction = (result: any) => {
    const details = Array.isArray(result?.details)
      ? result.details
      : Array.isArray(result?.rows)
        ? result.rows
        : Array.isArray(result?.items)
          ? result.items
          : [];

    const extractedRows = details.length > 0 ? details : (result ? [result] : []);
    const createBaseRow = (srno: number) => ({
      srno,
      identifier: "",
      revision: "",
      description: "",
      date: new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime)),
      tenantID: 0,
      createdbyName: this.state.createdName || "Select",
      createdby: this.state.createdId || 0,
      approvedbyName: "Select",
      approvedby: 0,
      status: "Obsolete",
    });

    return extractedRows.map((detail: any, index: number) => {
      const currentRow = createBaseRow(index + 1);

      const itemDescription = (
        detail?.itemDescription ||
        detail?.itemdescription ||
        detail?.description ||
        detail?.itemDesc ||
        ""
      ).toString().trim();

      return {
        ...currentRow,
        identifier: "",
        revision: "",
        description: itemDescription,
      };
    });
  };

  applyExtractedDocumentData = async (
    result: any,
    mode: "override" | "append" = "override"
  ) => {
    const extractedRows = this.buildDocumentRowsFromDrawingExtraction(result);
    const existingRows = Array.isArray(this.state.deposits) ? this.state.deposits : [];

    const depositRows =
      mode === "append"
        ? [
          ...existingRows,
          ...extractedRows.map((item: any, index: number) => ({
            ...item,
            srno: existingRows.length + index + 1,
          })),
        ]
        : extractedRows.map((item: any, index: number) => ({
          ...item,
          srno: index + 1,
        }));

    this.setState({
      deposits: depositRows,
      isStateChanged: true,
    });
  };

  confirmAndApplyExtractedDocumentData = (result: any) => {
    if (this.hasExistingDocumentLineItems()) {
      confirmAlert({
        title: "Existing line items found",
        message:
          "Do you want to replace the existing line items or append the extracted items?",
        buttons: [
          {
            label: "Override",
            onClick: () => this.applyExtractedDocumentData(result, "override"),
          },
          {
            label: "Append",
            onClick: () => this.applyExtractedDocumentData(result, "append"),
          },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
      });
      return;
    }

    this.applyExtractedDocumentData(result, "override");
  };

  handleExtractDrawingPdf = async () => {
    const extractionFile = await this.getPdfExtractionFile();
    if (!extractionFile) {
      return;
    }

    this.setState({ isExtracting: true, isSpinner: true });
    CustomerService.ExtractDrawingFromPdfVendor(extractionFile)
      .then((result: any | null) => {
        if (result) {
          this.confirmAndApplyExtractedDocumentData(result);
          toast.success("Document details extracted successfully.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
        }
      })
      .catch((error) => {
        toast.error(`Unable to extract details: ${error}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
      })
      .finally(() => {
        this.setState({ isExtracting: false, isSpinner: false });
      });
  };

  render() {
    const { showModal, uploadedFiles } = this.state;
    const { permissions } = this.props;
    const hasAddDocumentPermission = permissions && permissions['Add Document'] ? true : false;
    const hasEditDocumentPermission = permissions && permissions['Edit Document'] ? true : false;
    const hasSupplementaryFiles = this.state.savedfiles.length > 0 || this.state.newSelectfiles.length > 0;
    const supplementaryFiles = [...(this.state.savedfiles || []), ...(this.state.newSelectfiles || [])];
    const depositColumns = [
      {
        dataField: "srno",
        text: "Sr No.",
        headerStyle: { width: "4%" },
        style: { width: "4%" },
        hidden: !this.state.isControlled,
      },
      {
        dataField: "identifier",
        text: "Identifier",
        headerClasses: "coa",
        hidden: !this.state.isControlled,
        headerStyle: { width: "12%" },
        style: { width: "12%" },
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtidentifier" + rowIndex + "txt";
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Identifier"
                value={row.identifier}
                onChange={(e) => this.updateState(e, row, "rowidentifier", id)}
                autoComplete="off"
                //pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={200}
                disabled={false}
                title=""
              />
            </div>
          );
        },
      },
      {
        dataField: "revision",
        text: "Revision",
        headerClasses: "coa",
        hidden: !this.state.isControlled,
        headerStyle: { width: "8%" },
        style: { width: "8%" },
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtrevision" + rowIndex + "txt";
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Revision No."
                value={row.revision}
                onChange={(e) => this.updateState(e, row, "revision", id)}
                autoComplete="off"
                //pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={200}
                onKeyDown={(e: any) => this.onTAB("revision", rowIndex, e)}
                disabled={false}
                title=""
              />
            </div>
          );
        },
      },
      {
        dataField: "description",
        text: "Description",
        headerClasses: "coa",

        headerStyle: { width: "18%" },
        style: { width: "18%" },
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtdescription" + rowIndex + "txt";
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Please enter details"
                value={row.description}
                onChange={(e) => this.updateState(e, row, "description", id)}
                autoComplete="off"
                //pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={200}
                onKeyDown={(e: any) => this.onTAB("description", rowIndex, e)}
                disabled={false}
                title=""
              />
            </div>
          );
        },
      },
      {
        dataField: "date",
        text: "Date",
        headerStyle: { width: "16%" },
        style: { width: "16%" },
        hidden: false,
        editable: false,
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtdate" + rowIndex + "txt";
          // let disable = this.state.formData.CustomerID == 0 ? true : false;
          return (
            <div className="date-picker calender-picker" style={{ width: "100%" }}>
              <DatePicker
                ref={this.trDate}
                id={id}
                tabIndex={this.state.tabEnable}
                className="form-control form-control-sm w-100"
                wrapperClassName="w-100"
                placeholderText={"MM/DD/YY"}
                dateFormat="MM/dd/yy"
                onChangeRaw={this.handleRawChange}
                selected={
                  row.date === null
                    ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
                    : row.date === ""
                      ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
                      : new Date(row.date)
                }
                onChange={(e) => this.updateState(e, row, "date", id)}

                onKeyDown={(e: any) =>
                  this.onTAB.bind(
                    this,
                    "txtdate-" + rowIndex.toString() + "txt",
                    rowIndex
                  )
                }
                autoComplete="off"
              //onKeyDown={this.onTAB.bind(this, "txttotal-" + rowIndex.toString() + "txt", rowIndex)}
              //   disabled={disable}
              />
            </div>
          );
        },
      },

      {
        dataField: 'createdBy',
        text: 'Created By',
        headerStyle: { width: '13%' },
        style: { width: '13%' },
        //headerFormatter: this.iconFormatter,
        hidden: false,
        editable: false,
        headerAttrs: (column, colIndex) => (
          { 'tabIndex': '-1' }
        ),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtcreatedby" + rowIndex + "txt";
          return (
            <div className="w-full">
              {this.state.userdataList && this.state.userdataList.length > 0 && (

                <SingleDropdownListWithoutSearch
                  tabIndex={this.state.tabEnable}
                  itemList={this.state.userdataList}
                  handleSelectedItem={this.handleSelectedItem.bind(row, 2 + '_' + rowIndex)}
                  defaultItem={row.createdbyName}
                  defaultText={"Search User"}
                  defaultName={row.createdbyName}
                  controlID="1"
                  disabled={!this.state.isControlled}
                  id={"ddlcreatedby-" + rowIndex + "ddl"}
                //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}

                />

              )}


            </div>
          );

        },

      },
      {
        dataField: 'approvedBy',
        text: 'Approved By',
        headerStyle: { width: '13%' },
        style: { width: '13%' },
        //headerFormatter: this.iconFormatter,
        hidden: !this.state.isControlled,
        editable: false,
        headerAttrs: (column, colIndex) => (
          { 'tabIndex': '-1' }
        ),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtapprovedby" + rowIndex + "txt";
          return (
            <div className="w-full">
              {this.state.userdataList && this.state.userdataList.length > 0 && (

                <SingleDropdownListWithoutSearch
                  tabIndex={this.state.tabEnable}
                  itemList={this.state.userdataList}
                  handleSelectedItem={this.handleSelectedItem.bind(row, 3 + '_' + rowIndex)}
                  defaultItem={row.approvedbyName}
                  defaultText={"Search User"}
                  defaultName={row.approvedbyName}

                  controlID="1"
                  id={"ddlapprovedby-" + rowIndex + "ddl"}
                //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}

                />

              )}


            </div>
          );

        },

      },
      {
        dataField: 'status',
        text: 'Status',
        headerStyle: { width: '9%' },
        style: { width: '9%' },
        //headerFormatter: this.iconFormatter,
        hidden: false,
        editable: false,
        headerAttrs: (column, colIndex) => (
          { 'tabIndex': '-1' }
        ),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtstatus" + rowIndex + "txt";
          return (
            <div className="w-full">

              <SingleDropdownListWithoutSearch
                tabIndex={this.state.tabEnable}
                itemList={this.state.statusList}
                handleSelectedItem={this.handleSelectedItem.bind(row, 4 + '_' + rowIndex)}
                defaultItem={row.status}
                defaultText={"Search User"}
                defaultName={row.status}
                disabled={false}
                controlID="1"
                id={"ddlstatus" + rowIndex + "ddl"}
              //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}

              />

            </div>
          );

        },

      },
      {
        dataField: "isFile",
        text: "",
        headerClasses: "coa",
        headerStyle: { width: "6%" },
        style: { width: "6%" },
        classes: 'text-center',
        // hidden:this.state.formData.Id > 0 ? false : true,
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          const isFile = row.isFile === true;
          return (
            <div className="cursor-pointer" onClick={() => this.handleAttachmentClick(row, rowIndex)}>
              {isFile ? (
                <FontAwesomeIcon icon={faPaperclip} />
              ) : (
                <span style={{ color: "#164DA0", fontWeight: 500 }} className="align-middle lh-1">+add file</span>
              )}
            </div>
          );
        },
      },
      {
        dataField: "action",
        text: "Action",
        headerClasses: "coa",
        hidden: !this.state.isControlled,
        headerStyle: { width: "6%" },
        style: { width: "6%" },
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          const isFirstRow = rowIndex === 0 || row.srno === 1;
          if (isFirstRow) {
            return null;
          }
          return (
            <div className="btn-group">
              <Dropdown
                onClick={(e) => { e.stopPropagation(); }}
                className="more-action"
              >
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary-white more border-0"
                  id={"dropdown-more-row-" + rowIndex}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item
                    eventKey={"delete"}
                    onClick={() => this.handleDeleteRow(row, rowIndex)}
                  >
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },

      // {
      //   dataField: "Attachment",
      //   text: "",
      //   //headerFormatter: this.iconFormatter,
      //   headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      //   formatter: (cell: any, row: any, rowIndex: any) => {
      //     let itemDetailConfirmModalContent = [
      //       {
      //         title: "Delete Row",
      //         desc: "Are you sure you want to delete?",
      //         cancleAction: "Cancel",
      //         ActionTrue: "Delete",
      //       },
      //     ];
      //     // if (this.state.additionalMaterialItems.length >= 0) {
      //     //   return (
      //     //     <div></div>
      //     //   );
      //     // }
      //     // else {
      //     return (
      //       <Dropdown
      //         className="more-action confirmation-modal"
      //         tabIndex={this.state.tabDisable}
      //       >
      //         <Dropdown.Toggle
      //           className="btn-outline-primary btn btn-primary more fa-trash"
      //           id="dropdown-more-delete"
      //           tabIndex={this.state.tabDisable}
      //         >
      //           <svg
      //             width="20"
      //             height="20"
      //             viewBox="0 0 20 20"
      //             fill="none"
      //             xmlns="http://www.w3.org/2000/svg"
      //           >
      //             <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
      //           </svg>
      //         </Dropdown.Toggle>
      //         <Dropdown.Menu>
      //           <ConfirmationModal
      //             confirmModalContent={itemDetailConfirmModalContent}
      //             ishandleDeletePosition={this.handleDeleteRow.bind(this, row)}
      //           />
      //         </Dropdown.Menu>
      //       </Dropdown>
      //     );
      //     // }
      //   },
      // },
    ];


    const files1 = [...(this.state.savedfiles || []), ...(this.state.newSelectfiles || [])].map((file, index) => (
      <>
        <div>
          <li key={file.id || file.fileUniqueno || file.name}>
            <div className="d-flex align-items-center justify-content-start">

              <div className="file-info d-flex align-items-center">
                <div className="name-loader d-flex align-items-center">
                  <div className="name">
                    {/* <EllipsisWithTooltip placement="bottom"> */}
                    <div className="full-name" style={{ fontSize: '14px', textAlign: 'left' }}>{file.name}</div>
                    {/* </EllipsisWithTooltip> */}
                  </div>
                </div>
              </div>
              <div className="action">
                {
                  file?.isLocalAttachment ? (
                    <Dropdown
                      className="more-action"
                      onSelect={(event: any) =>
                        this.handleSelectFileUpload(event, file, index)
                      }
                    >
                      <Dropdown.Toggle
                        className="btn-outline-primary btn btn-primary more border-0"
                        id="dropdown-more"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item eventKey="delete">Delete</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <Dropdown
                      className="more-action"

                      onSelect={(event: any) =>
                        this.handleSelectFileUpload(event, file, index)
                      }
                    >
                      <Dropdown.Toggle
                        className="btn-outline-primary btn btn-primary more border-0"
                        id="dropdown-more"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {this.state.moreActionFileUpload1.map(
                          (item: any, idx: any) => (
                            <>
                              {this.state.formData.Id === 0 && (
                                <Dropdown.Item
                                  //  className={( this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                                  //className={((this.state.formData.actionType === "copy" || this.state.isError === "NotEdit") && this.state.formData.uniqueno > 0) ? "isHide" : ""}
                                  eventKey={
                                    this.state.moreActionFileUpload1[idx].eventKey
                                  }
                                  key={idx}
                                >
                                  {this.state.moreActionFileUpload1[idx].name}
                                </Dropdown.Item>
                              )}

                              {this.state.formData.Id > 0 && (
                                <Dropdown.Item
                                  // className={(    this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                                  eventKey={
                                    this.state.moreActionFileUpload1[idx].eventKey
                                  }
                                  key={idx}
                                >
                                  {this.state.moreActionFileUpload1[idx].name}
                                </Dropdown.Item>
                              )}
                            </>
                          )
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )
                }
              </div>
            </div>
          </li>
        </div>
      </>
    ));
    const savedfilesCount = supplementaryFiles.length;
    const allsavedfiles = supplementaryFiles;
    const currentView = this.state.defaultView;

    const handleUpdate = (newtext) => {
      //this.setState({ defaultView: "doc-view"});
      toggleSwitch("doc-view");
      setTimeout(function () {
        var currentPos: any = $(`#${newtext}`).offset()?.top;
        var marginArea = currentPos - 138;
        $(".scroll-area").animate(
          {
            scrollTop: marginArea,
          },
          500
        );
      }, 500);
    };

    const handleUpdateFiles = (docFiles) => {
      //let docViewerFiles : any =[];
      docViewerFiles.push(docFiles);
      //this.setState({ docViewerFiles: docFiles })
    };

    const showBulkSelect = (type) => {
      this.setState({ bulkSelect: type === "show" ? true : false });
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.showBulkSelect();
      }
    };

    const checkBulkSelect = (type, totalpage) => {
      // selectedPage =totalpage;
      if (totalpage === 0) {
        this.footerchk.current.labels[0].innerHTML = "No Page Selected";
      } else if (totalpage === 1) {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Page Selected";
      } else {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Pages Selected";
      }
      if (type === "removeAll") {
        this.footerchk.current.indeterminate = false;
        this.footerchk.current.checked = false;
      } else {
        if (type === "helf") {
          this.footerchk.current.indeterminate = true;
        } else {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = true;
        }
      }
    };

    const toggleSwitch = (event: any) => {
      this.setState({ defaultView: event });
      $(".scroll-area").animate(
        {
          scrollTop: 0,
        },
        500
      );
    };

    return (
      //  <div className="transaction-slideout invoice-entry pos-fxd index-1000">

      <section>
        <div
          className="details-drawer"
          style={{ minWidth: "80%", width: "1140px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />

          <div className="d-flex">


            {!this.state.isOpenViewer && (
              <div
                className="back-drop1  viewer-panel1 opacity"
              // onClick={() => this.closeSlideOut()}
              ></div>
            )}

            {this.state.isOpenViewer && (
              <div
                className="back-drop viewer-panel-left bg-secondary bg-gradient z-3 position-absolute"
                //className="body-sec viewer-panel back-drop p-0 z-3"
                style={{ minWidth: "40%", width: "420px", maxWidth: "100%" }}

              >
                <div
                  className="scroll"
                >
                  <div className="header-panel d-flex justify-content-between align-items-center">
                    <div className="page-ttl">Attachments</div>
                    {/* <div className="toggle-button">
                    <ButtonGroup aria-label="Basic example">
                      <ToggleButtonGroup
                        type="radio"
                        name="options"
                        value={this.state.defaultView}
                        onChange={toggleSwitch}
                      >
                        <ToggleButton value={"doc-view"} id={"t1"}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                            <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                          </svg>
                        </ToggleButton>
                        <ToggleButton value={"grid-view"} id={""}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                          </svg>
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </ButtonGroup>
                  </div> */}
                    <div className="action d-flex">
                      {this.state.isextractShow && (
                        <div className="d-flex align-items-center gap-2 me-4">
                          <Button
                            onClick={this.handleExtractDrawingPdf}
                            disabled={this.state.isExtracting || this.state.isSpinner}
                          >
                            {this.state.isExtracting || this.state.isSpinner ? "Extracting..." : "Extract"}
                          </Button>
                        </div>
                      )}
                      <button
                        type="button"
                        className="btn wht-bg cross"
                        style={{ backgroundColor: '#164DA0' }}
                        onClick={this.OpenViewer}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <ScrollContainer
                    className="doc-view scroll-area1"
                    // className={`scroll-area ${this.state.modalOpen === "yes" ? "modal-open" : ""
                    //   } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}


                    ref={this.scrollheight}
                    hideScrollbars={false}
                  >
                    <>
                      {(this.state.singleView ? this.state.singleViewFiles : this.state.separateView ? this.state.savedfilesSeparate : supplementaryFiles).map((file: any, i: any) => {
                        return (
                          <div
                            id={`sec_${file.id}`}
                            className={this.state.bulkSelect ? "footer-enable" : ""}
                          >
                            <div
                              className={
                                currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                              }
                            >
                              <PDFViewer
                                //ref={childViewerref}
                                ref={this["myRef" + i]}
                                scrollAreaHeight={this.state.scrollAreaHeight}
                                isModalOpen={this["isModalOpen"]}
                                uniqueno={this.state.orderID}
                                filePreview={file.fileCode}
                                defaultView={currentView}
                                fileNo={file.fileUniqueno}
                                fileCount={savedfilesCount}
                                fileName={file.name}
                                // docFile={docViewerFiles}
                                docFile={allsavedfiles}
                                updateState={handleUpdate}
                                updateFiles={handleUpdateFiles}
                                showBulkSelect={showBulkSelect}
                                checkBulkSelect={checkBulkSelect}
                                handleFileCheckBox={this["handleFileCheckBox"]}
                                handleUpdatedFile={this["handleUpdatedFile"]}
                                handleincompleteFile={this["handleincompleteFile"]}
                                saveSplitFile={this["saveSplitFile"]}
                                pageType={this.props.pageType}
                                handleRotate={this["handleRotate"]}
                                handlePageRemove={this["handlePageRemove"]}
                                selectedChk={this.state.selectedChk}
                                selectedZoom={this.state.currentZoom}
                                setTotalPages={this["setTotalPages"]}
                                isExtractMode={this.state.isextractShow}
                                isEditPermission={true}
                              />
                            </div>
                          </div>
                        );
                      })}

                      {currentView === "doc-view" && (
                        <div className="zoom-btn">
                          <ButtonGroup vertical>
                            <Button
                              onClick={(e) => this.handleZoom("zoomIn")}
                              disabled={
                                this.state.currentZoom >= 3.375 ? true : false
                              }
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </Button>
                            <Button
                              onClick={(e) => this.handleZoom("zoomOut")}
                              disabled={
                                this.state.currentZoom <= 0.44 ? true : false
                              }
                            >
                              <FontAwesomeIcon icon={faMinus} />
                            </Button>
                          </ButtonGroup>
                        </div>
                      )}
                      {/* {this.state.bulkSelect && (
                        <div className="footer-section-left d-flex align-items-center justify-content-end">
                          <Form.Check

                            type="checkbox"
                            key={"custom-footer"}
                            id={"custom-footer"}
                            label={"No Page Selected"}
                            onChange={(e: any) => this.handleAllCheckbox(e)}
                            ref={this.footerchk}
                          />
                        </div>
                      )} */}
                    </>
                  </ScrollContainer>
                </div>
              </div>
            )}

            <Container
              fluid
              className="body-sec viewer-panel back-drop p-0 "
              style={{ minWidth: "60%", width: "400px", maxWidth: "100%" }}
            >
              <div className="container-fluid py-1 bg-white d-flex align-items-center round-4">
                <div className="divheader">
                  <h5 className="my-title">{this.state.formData.Id ? `Document ID: ${this.state.stringId || this.state.docNumber}` : 'New Document'}</h5>
                  <div className="header-popout ml-auto">
                    <div className="container text-center">
                      <div className="row align-items-start">
                        <div className="col">
                        </div>
                        <div className="col p-0">
                          {this.state.formData.Id != 0 && !this.state.isOpenViewer && (
                            <div className="action">
                              <Dropdown
                                className="more-action"
                                onSelect={(event: any) => { this.moreActions(event); }}
                              >
                                <Dropdown.Toggle
                                  className="btn-outline-primary btn btn-primary more"
                                  id="dropdown-more"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    eventKey={"Delete"}
                                    key={1}
                                  >
                                    {"Delete"}
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          )}
                        </div>

                        <div className="col">
                          <div className="container text-center">
                            <div className="row align-items-start">
                              <div className="col d-none"></div>
                              {!this.state.isOpenViewer && (
                                <div className="col">
                                  <button
                                    type="button"
                                    className="btn btn-primary cross"
                                    onClick={this.closeSlideOut}
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                        fill="#ffffff"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="scroll">
                <section className="pb-3">


                  <div className="row g-3">

                    {this.state.isDocumentLoad && this.state.formData.documentType !== "" &&

                      <div className="col-12 col-md-3">
                        <Form.Label className="font-semibold">Document Category</Form.Label>
                        <div className="w-full" >
                          <Form.Label style={{ width: '100%' }}>



                            <DocumentTypeSearch
                              tabIndex={this.state.tabEnable}
                              itemList={this.state.documentList}
                              handleSelectedItem={this.handleSelectedItem1.bind(this, 5)}
                              defaultItem={this.state.formData.documentType}
                              defaultText={"Search"}
                              defaultName={this.state.formData.documentType}
                              getjobdata={this.getDocumentTypes1}
                              controlID="1"
                              id={"ddldocumentTypeddl"}
                            //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}

                            />

                          </Form.Label>
                        </div>
                      </div>}
                    {/* <div className="col-12 col-md-3">
                        <Form.Label className="font-semibold">
                                                                      Identifier
                                                                    </Form.Label>
                                                                    <Form.Control
                tabIndex={this.state.tabEnable}
                id={"identifier"}
                type="text"
                placeholder="Enter"
                value={this.state.formData.identifier}
                onChange={(e) => this.updateState(e, null, "identifier", "Identifier")}
                autoComplete="off"
                //pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={200}
                // onKeyDown={(e: any) => this.onTAB("revision", rowIndex, e)}
                disabled={false}
                title=""
              />
                    </div> */}
                    {/* <div className="col-12 col-md-3">
                      <Form.Label className="font-semibold">Department</Form.Label>
                                              <div className="w-full" >
                                              <Form.Label style={{width:'100%'}}>
                                              {this.state.isDepartmentLoad &&  this.state.formData.department !== "" &&
                                        
             
                                            <DepartmentSearch
                                                          tabIndex={this.state.tabEnable}
                                                          itemList={this.state.departmentList}
                                                          handleSelectedItem={this.handleSelectedItem1.bind(this,4)}
                                                          defaultItem={this.state.formData.department}
                                                          defaultText={"Search"}
                                                          defaultName={this.state.formData.department}
                                                          getjobdata={this.getDepartment}
                                                          controlID="1"
                                                          id={"ddldepartment"}
                                                        //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
                                            
                                                        />
                                              }
                                            </Form.Label>
                                            </div>
                    </div> */}
                    <div className="col-12 col-md-3 px-5" >
                      {this.state.userdataList.length > 0 && this.state.userLoad && (
                        <div className="col-sm-9 selectRolesMultiSelect" style={{ maxWidth: "fit-content", marginBottom: '13%' }}>
                          <div className="w-auto" >
                            <Form.Label className="font-semibold">User Access</Form.Label>

                            <DocMultiSelect
                              name="JO"
                              data={this.state.userdataList}
                              isSelectAll={true}
                              label="label"
                              value="value"
                              placeHolder="Select"
                              filtertitle="Filter Users"
                              updateMultiSelectItem={this.updateMultiSelectItem}
                            />
                          </div>
                        </div>
                      )}

                    </div>


                  </div>
                </section>

                {/* <div className="scroll p-0"> */}
                <div className="table-responsive1" >

                  <section className="pb-3 mt-1">
                    <div className="card">
                      <div className="card-header fw-bold">Details</div>
                      <div className="card-body">
                        <div
                          //   className="transactions-list inpute"
                          //  className="table table-borderless align-middle  transactions-list"
                          className="table table-borderless align-middle transactions-list"
                        >
                          {this.state.userdataList.length > 0 && this.state.userLoad &&
                            <div className="split-assign-coa">
                              <BootstrapTable
                                key={this.state.isControlled}
                                id="tblAdditionalMaterialItems"
                                keyField="templateid"
                                data={this.state.deposits}
                                columns={depositColumns}

                              />
                            </div>
                          }
                        </div>




                        <div className="d-flex action-btn align-items-center">
                          {this.state.isControlled && (
                            <Button
                              type="button"
                              className="btn-ghost mr-auto"
                              onClick={this.handleNewRow}
                            >
                              <FaCirclePlus className="align-middle lh-1`" />{" "}
                              <span className="align-middle lh-1">Add row</span>
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                  <hr></hr>
                  <div >
                    {
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <div
                            className="filter-sec upload-section"
                          >

                            <Form.Group className="w-100">

                              <div>
                                <Form.Label>
                                  {
                                    <div className="upload-link mrgn-top">
                                      <button
                                        type="button"
                                        className="btn wht-bg link-btn mr-auto"
                                      >
                                        {/* Supplementary Documents */}
                                        Add Attachment
                                      </button>
                                      <Form.Control
                                        id="formControlsFile"
                                        type="file"
                                        className="form-control-file"
                                        multiple
                                        disabled={!hasEditDocumentPermission}
                                        onChange={(event: any) =>
                                          this.onFileChange(event, "1")
                                        }
                                        // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml,
                                        // .stp,.step,.igs,.iges,.stl,.sldprt,.sldasm,.dwg,.dxf,.catpart,.catproduct,.ipt,.iam"
                                        accept="*"
                                      />
                                    </div>

                                  }
                                </Form.Label>

                                {hasSupplementaryFiles && (
                                  <Form.Label className="mr-auto">
                                    <div className="upload-link mrgn-top">
                                      <button
                                        type="button"
                                        className="btn wht-bg link-btn mr-auto"
                                        onClick={this.OpenViewer}
                                      // data-bs-toggle="modal" data-bs-target="#exampleModal"
                                      >
                                        {this.state.isOpenViewer
                                          ? "Close Viewer"
                                          : "Open Viewer"}
                                      </button>
                                    </div>
                                  </Form.Label>
                                )}

                                <div className="mt-1 py-3 rounded-3 text-center text-secondary"
                                  style={{ border: "solid 1px #c0c0c0" }}>
                                  <Dropzone
                                    // disabled={isBedgeProcessing}
                                    disabled={!hasEditDocumentPermission}
                                    onDrop={this.onDrop}
                                  // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                  >
                                    {({
                                      getRootProps,
                                      getInputProps,
                                      isDragActive,
                                      isDragReject,
                                    }) => (
                                      <>
                                        <aside style={{ paddingBottom: '56px' }}>
                                          {/* <ul>{files}</ul> */}
                                          <ul>{files1}</ul>
                                          <ul style={{ textAlign: 'left' }}>
                                            {hasSupplementaryFiles && (

                                              <Form.Label>
                                                {
                                                  <div className="upload-link mrgn-top">
                                                    <button
                                                      type="button"
                                                      className="btn"
                                                      style={{ fontSize: '14px' }}
                                                      onClick={this.handleButtonClick}
                                                    >
                                                      <FaCirclePlus style={{ color: '#164DA0' }} className="align-middle lh-1`" />{" "}
                                                      <span style={{ color: '#164DA0' }}>Add Attachment</span>
                                                    </button>
                                                    <Form.Control
                                                      id="formControlsFile"
                                                      type="file"
                                                      ref={this.fileInputRef}
                                                      className="form-control-file"
                                                      multiple
                                                      disabled={!hasEditDocumentPermission}
                                                      onChange={(event: any) =>
                                                        this.onFileChange(event, "1")
                                                      }
                                                      // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                      accept="*"
                                                    />
                                                  </div>
                                                }
                                              </Form.Label>

                                            )}</ul>
                                        </aside>
                                        <section className="container upload-area default">
                                          {/* {!this.state.bulkSelect && ( */}
                                          {this.state.savedfiles.length < 1 && (
                                            <div
                                              {...getRootProps({
                                                className:
                                                  "dropzone align-items-center",
                                                onClick: (event) => event,
                                                // this.state.newSelectfiles.length > 0 ||
                                                //   this.state.savedfiles.length > 0
                                                //   ? (event) => event.stopPropagation()
                                                //   : (event) => event,
                                              })}
                                            >
                                              <input {...getInputProps()} />
                                              {/* {this.state.newSelectfiles.length < 1 && */}
                                              {(!hasSupplementaryFiles) && (
                                                <p>
                                                  Drag and drop attachment or{" "}
                                                  <span>browse files</span> to upload.
                                                </p>
                                              )}
                                              {(this.state.newSelectfiles.length > 0 ||
                                                this.state.savedfiles.length > 0)
                                                &&
                                                isDragActive && (
                                                  <p>
                                                    Drag and drop attachment here to upload.
                                                  </p>
                                                )}
                                            </div>
                                          )}

                                        </section>


                                      </>
                                    )}

                                  </Dropzone>

                                </div>
                              </div>
                            </Form.Group>
                          </div>

                        </div>


                        {/* <div className="col-12 col-md-6">
                      {(this.state.formData.journalEntryID != 0 &&
                        <CommentBox
                          ref={this.ChildComment}
                          hotelid={this.state.hotelValue}
                          entryType={"journal"}
                          //={this.state.formData.actionType === "copy" ? 0 : this.props.pageType === "Invoice" ? this.state.formData.uniqueno : this.state.formData.incompleteUniqueno}
                          uniqueNo={this.state.formData.journalEntryID}
                          precommentlist={this.state.htmlcomment}
                          parentScrollMethod={this.scrollToBottom}
                          updatedCommentItem={this.updatedCommentItem}
                          commentModalClose={this.CommentModalClose}

                        />
                      )}
                    </div> */}
                      </div>
                    }
                  </div>
                </div>
                {/* </div> */}

                <div className="filter-sec height-172">

                  <br></br>
                  <br></br>

                </div>


                <div
                  className={"footer-section-new viewer-panel"}
                  style={{ minWidth: "60%", width: "400px", maxWidth: "100%" }}
                >
                  <div>
                    <div className="d-flex gap-3 align-items-center justify-content-end height-72">
                      {this.state.isStateChanged && (
                        <div className="mr-auto message">
                          <span style={{ color: "#065a8c" }}>
                            You have unsaved changes
                          </span>
                        </div>
                      )}

                      <div className="d-flex gap-3 align-items-center">
                        {/* {this.state.formData.journalEntryID === 0 &&
                        <div>
                        <Form.Group controlId="toggleSearch">
                          <Form.Check
                            type="checkbox"
                            label="Create new"
                            checked={this.state.creatNew}
                            onChange={this.handleCloseCheckboxChange}
                          />
                        </Form.Group>
                        </div>
                        } */}
                        <Button
                          variant="primary"
                          type="button"
                          className="space btn btn-primary btn-discard"
                          onClick={() =>
                            this.handleDiscard(this.state.orderUniqueNo)
                          }
                        >
                          Discard
                        </Button>

                        {((hasEditDocumentPermission && this.state.formData.Id > 0) || (hasAddDocumentPermission && this.state.formData.Id === 0)) &&
                          (
                            <>
                              <Button
                                id="btnSaveVendor"
                                variant="primary"
                                type="button"
                                onClick={() => { this.saveDeposit(false); }}
                              >
                                Save
                              </Button>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>

          {this.state.unsave && (
            <div
            //className="d-flex align-items-center pos-fxd2 index-1000"
            >
              <div className="react-confirm-alert-overlay confirm-modal undefined">
                <div className="react-confirm-alert">
                  <div className="react-confirm-alert-body">
                    <h1>Confirmation</h1>
                    Please save this record before adding attachment.
                    <div className="react-confirm-alert-button-group">
                      <button
                        type="button"
                        className="btn"
                        onClick={() => {
                          this.setState({ unsave: false });
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn"
                        onClick={() => { this.saveDeposit(true); }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}


          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}



          {(this.state.isSpinnerdoc) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center flex-column">
              <p style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>Opening document</p>
              <Spinner animation="border" variant="success" />
            </div>
          )}


          {this.state.showModal &&
            <DocumentAttachment attachId={this.state.attachId}
              showModal={this.state.showModal}
              onClose={this.closeModal}
              getDeposits={this.getDeposits}
            />
          }
        </div>

      </section>


    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(DocumentSlideout);
